import React from 'react';

export const DownloadIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.66 0H5.33C1.92 0 0 1.92 0 5.33V14.67C0 18.06 1.92 20 5.33 20H14.67C18.07 20 20 18.06 20 14.67V5.33C20 1.92 18.06 0 14.66 0ZM10.016 4.64502C10.4302 4.64502 10.766 4.98081 10.766 5.39502V12.6204L12.4006 10.9791C12.6928 10.6856 13.1677 10.6846 13.4612 10.9769C13.7547 11.2692 13.7557 11.744 13.4634 12.0375L10.5474 14.9655C10.4067 15.1069 10.2154 15.1863 10.016 15.1863C9.81653 15.1863 9.6253 15.1069 9.48456 14.9655L6.56856 12.0375C6.27627 11.744 6.27724 11.2692 6.57074 10.9769C6.86423 10.6846 7.3391 10.6856 7.63139 10.9791L9.26596 12.6204V5.39502C9.26596 4.98081 9.60175 4.64502 10.016 4.64502Z" fill="#6A6D73"/>
    </svg>
  )
}
